import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type CreateAccountConnectionMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.CreateAccountConnectionInput;
}>;

export type CreateAccountConnectionMutationResult = { __typename?: 'Mutation' } & {
  createAccountConnection?: GraphQLTypes.Maybe<
    { __typename?: 'CreateAccountConnectionPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const CreateAccountConnectionMutationDocument = /*#__PURE__*/ gql`
  mutation createAccountConnectionMutation($input: CreateAccountConnectionInput!) {
    createAccountConnection(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useCreateAccountConnectionMutation__
 *
 * To run a mutation, you first call `useCreateAccountConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountConnectionMutation, { data, loading, error }] = useCreateAccountConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountConnectionMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateAccountConnectionMutationResult, CreateAccountConnectionMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<CreateAccountConnectionMutationResult, CreateAccountConnectionMutationVariables>(
    CreateAccountConnectionMutationDocument,
    options
  );
}
export type CreateAccountConnectionMutationHookResult = ReturnType<typeof useCreateAccountConnectionMutation>;
